import { render } from "./DesignThinking.vue?vue&type=template&id=79b97c0c&scoped=true"
import script from "./DesignThinking.vue?vue&type=script&lang=js"
export * from "./DesignThinking.vue?vue&type=script&lang=js"

import "./DesignThinking.vue?vue&type=style&index=0&id=79b97c0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b97c0c"]])

export default __exports__